import apiBase from './apiBase';

class VouchersApi {
  static getPromotions() {
    return apiBase.create().get('/operations/voucher-promotions');
  }

  static getPromotion(id) {
    return apiBase.create().get(`/operations/voucher-promotions/${id}`);
  }

  static createPromotion(data) {
    return apiBase.create().post('/operations/voucher-promotions', data);
  }

  static disablePromotion(id) {
    return apiBase.create().post(`/operations/voucher-promotions/${id}/disable`);
  }
}

export default VouchersApi;
